import { render, staticRenderFns } from "./customer_edit.vue?vue&type=template&id=753ba68a&scoped=true"
import script from "./customer_edit.vue?vue&type=script&lang=js"
export * from "./customer_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753ba68a",
  null
  
)

export default component.exports